import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PARTNER_SLUG } from '@/shared/lib/partner';
import '@/styles/index.scss';
import './shell.scss';
import { App } from './App';
import { hideSplash } from './splash';

const container = document.getElementById('ls-root');
if (!container) throw new Error('Не найден контейнер #ls-root');

// Набор мер заказчика цепляется к корню ровно так же, как в виджете:
// ни один экран не знает, у какого он заказчика и на какой поверхности.
//
// Страница ставит то же самое ещё до загрузки сборки — чтобы меры
// действовали с первого кадра. Здесь строка остаётся как источник
// правды: слаг читается тем же модулем, что и везде, и расхождение
// с подстраховкой в разметке невозможно.
container.dataset.brand = PARTNER_SLUG;

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Заставка снимается после того, как дерево отрисовано, а не по таймеру
// от загрузки: иначе она уходит в тот момент, когда под ней ещё пусто.
requestAnimationFrame(() => requestAnimationFrame(hideSplash));
